import React from 'react';
import { BarChart, Bar, ResponsiveContainer, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Cell, Label } from 'recharts';
import BarChartTemplate2 from './BarChartTemplate2';
import BarChartTemplate3 from './BarChartTemplate3';

class BARCHART extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0
    }
  }

  render() {
    const { graphData, colors, legendName, xLabel, yLabel, graphHeight, series, barChartConfig, allowAddition, generatedActionCodeForAllowAddition, inlineActions, triggerAction, workflow, triggerData, companyDetails } = this.props;
    const barSize = barChartConfig && parseInt(barChartConfig.barSize);
    const barColor = barChartConfig && barChartConfig.barColor;
    const oneColorOnly = barChartConfig && barChartConfig.oneColorOnly;
    const { activeTab } = this.props
    const reportLibraryTemplate = companyDetails && companyDetails.companySettings && companyDetails.companySettings.reportLibraryTemplate ? companyDetails.companySettings.reportLibraryTemplate : "TEMPLATE_ONE"
    console.log(`props in barchart`, this.props)
    const barchartTemplate = barChartConfig && barChartConfig.barReportTemplate && barChartConfig.barReportTemplate.value
    console.log(`props in barchart 1`, barchartTemplate, reportLibraryTemplate)
    return (
      <div>
        {
          reportLibraryTemplate === "TEMPLATE_ONE" &&

          <div>
            {
              (barchartTemplate === "template1" || !barchartTemplate) &&
              <div style={{ width: '100%', cursor: 'pointer' }} className='reportMainContainer'>

                <ResponsiveContainer height={graphHeight}>
                  <BarChart data={graphData} margin={{ top: 0, right: 10, left: 5, bottom: 20 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="xProperties">
                      <Label value={xLabel} offset={0} position="bottom" />
                    </XAxis>
                    <YAxis label={{ value: yLabel, angle: -90, position: "inside", offset: -15, dx: 40 }} />
                    <Tooltip />
                    <Legend verticalAlign="top" height={36} />
                    {
                      series ? series.map((y, index) => {
                        return <Bar name={y.legendName} dataKey={y.yPropertyName} barSize={barSize}>
                          {
                            graphData && graphData.map((entry, index) => {
                              return <Cell key={`cell-${index}`} fill={oneColorOnly ? barColor : colors[index]} stroke={oneColorOnly ? barColor : colors[index]} strokeWidth={index === 2 ? 4 : 1} />
                            })
                          }
                        </Bar>
                      }) :
                        <Bar name={legendName} dataKey="yProperties" maxBarSize={barSize}>
                          {
                            graphData && graphData.map((entry, index) => {
                              return <Cell key={`cell-${index}`} fill={oneColorOnly ? barColor : colors[index]} stroke={oneColorOnly ? barColor : colors[index]} strokeWidth={index === 2 ? 4 : 1} />
                            })
                          }
                        </Bar>
                    }

                  </BarChart>
                </ResponsiveContainer>
              </div>
            }
            {
              barchartTemplate === "template2" &&
              <BarChartTemplate2 {...this.props} />
            }
            {
              barchartTemplate === "template3" &&
              <BarChartTemplate3 {...this.props} />
            }
          </div>

        }{
          reportLibraryTemplate === "TEMPLATE_TWO" &&
          <BarChartTemplate2 {...this.props} />
        }
      </div>


    );
  }
}

export default BARCHART;